import { render, staticRenderFns } from "./comTerm0.vue?vue&type=template&id=745bfbbc&scoped=true&"
import script from "./comTerm0.vue?vue&type=script&lang=js&"
export * from "./comTerm0.vue?vue&type=script&lang=js&"
import style0 from "./comTerm0.vue?vue&type=style&index=0&id=745bfbbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745bfbbc",
  null
  
)

export default component.exports